/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { Link } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import {
  useSendFullStoryEvent,
  useTrackEvent,
  useTrackingContext,
} from '@zapier/toolbox-tracking';

import {
  Props as UseEndOfYearSaleProps,
  useEndOfYearSale,
} from '../useEndOfYearSale';

const rootStyles = css`
  display: flex;
  justify-content: space-between;
`;

const EndOfYearSaleTopBarBanner = () => {
  const eventName = 'Viewed End of Year Sale TopBar Banner (2020)';

  useSendFullStoryEvent(eventName);
  useTrackEvent(`revenue: ${eventName}`);

  const { trackEvent } = useTrackingContext();

  return (
    <div css={rootStyles}>
      <span>
        <strong>Zapier Year-End Sale</strong> - Save 30% off Zapier annual plans
        until December 31st
      </span>

      <Link
        href="/app/billing/plans"
        onClick={() =>
          trackEvent('revenue: clicked End of Year sale plans link')
        }
      >
        See Plans
      </Link>
    </div>
  );
};

EndOfYearSaleTopBarBanner.shouldRender = function shouldRender(
  props: UseEndOfYearSaleProps = {}
) {
  return useEndOfYearSale.call(this, props)?.shouldRenderTopBarBanner;
};

export { EndOfYearSaleTopBarBanner };
